import React from "react";
import { Link, useLocation } from "react-router-dom";
import SocialProfiles from "./SocialProfiles";
import { useLeonardoLocale } from "scenes/leonardoNikolai/LeonardoLocaleContext";

const Footer = () => {
  const { pathname } = useLocation();
  const { shellT } = useLeonardoLocale();
  const isHomeFooter = pathname === "/";

  return (
    <footer id="site-footer" className={isHomeFooter ? "footer-home" : "footer-page"}>
      <div className="footer-grid">
        <div className="footer-col">
          <h4>{shellT("shell.footer.offer")}</h4>
          <ul>
            <li><Link to="/buchen">{shellT("shell.footer.book")}</Link></li>
            <li><Link to="/shop">{shellT("shell.footer.shop")}</Link></li>
            <li><Link to="/empfehlungsprogramm">{shellT("shell.footer.referral")}</Link></li>
            <li><Link to="/kontakt">{shellT("shell.footer.contact")}</Link></li>
            <li><Link to="/karriere">{shellT("shell.footer.career")}</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>{shellT("shell.footer.account")}</h4>
          <ul>
            <li><Link to="/einloggen">{shellT("shell.footer.login")}</Link></li>
            <li><Link to="/registrieren">{shellT("shell.footer.register")}</Link></li>
            <li><Link to="/konto">{shellT("shell.footer.myAccount")}</Link></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>{shellT("shell.footer.contact")}</h4>
          <ul>
            <li>MediConsult GmbH</li>
            <li>Cremon 11</li>
            <li>20457 Hamburg</li>
            <li>
             <a href="mailto:info@dr-hoffmann-massage.de">
              info@dr-hoffmann-massage.de
            </a>
            </li>
          </ul>
        </div>
        <SocialProfiles
          className="footer-socials footer-social-column"
          iconClassName="footer-social-icon"
          showLabels={false}
          label="Social-Media-Profile"
        />
      </div>
      <div className="footer-bottom">
        <span>
          &copy; {new Date().getFullYear()} MediConsult GmbH · {shellT("shell.footer.rights")}
        </span>
        <div>
          <Link to="/agbs">AGB</Link>
          <Link to="/impressum">{shellT("shell.footer.imprint")}</Link>
          <Link to="/datenschutz">{shellT("shell.footer.privacy")}</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
